import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledHelpIconButton } from "./styles";

type HelpButtonProps = Pick<IPlainTooltipProps, "tooltipContent"> & {
    dataAutomation: string;
    href: string;
    tooltipPlacement?: string;
};

const HelpLink = (props: HelpButtonProps) => {
    const {
        href,
        tooltipContent = <I18n translatable={{ key: "page.title.education.icon.tooltip" }} />,
        tooltipPlacement = "top",
        dataAutomation,
    } = props;

    return (
        <PlainTooltip
            placement={tooltipPlacement}
            tooltipContent={tooltipContent}
        >
            <a
                target="_blank"
                rel="noreferrer"
                href={href}
            >
                <StyledHelpIconButton
                    type="flat"
                    iconSize="sm"
                    iconName="learning-hat"
                    dataAutomation={dataAutomation}
                />
            </a>
        </PlainTooltip>
    );
};

export default HelpLink;
